import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';

class DropDownChonTienDoThanhTra extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label } bindValidator={this} channel="formTaoDon" require={this.props.require} selectedValue={this.props.selectedValue} options={ this.props.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownChonTienDoThanhTra.defaultProps = {
  label: 'Tiến độ',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: [
    {giaTri: 'Đang tiến hành', ten: 'Đang tiến hành'},
    {giaTri: 'Hoàn thành', ten: 'Hoàn thành'}
  ]
}


export default validatable(DropDownChonTienDoThanhTra);


// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonTienDoThanhTra.jsx